import '@ant-design/v5-patch-for-react-19'
import { createRoot } from 'react-dom/client'

import { App } from './App'
import { ErrorBoundary } from './components/ErrorBoundary'
import './lib/devCheats'
import './lib/init'

const container = document.getElementById('root')

if (container) {
  createRoot(container).render(
    <ErrorBoundary>
      <App />
    </ErrorBoundary>,
  )
}
